var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-entry",class:{ voted: _vm.userHasVoted },on:{"click":function($event){return _vm.$emit('questionClicked', _vm.question.questionId)}}},[_c('span',[_vm._v(_vm._s(_vm.question.texts[_vm.lang]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }